<div class="container-price-team">
  <div class="head">
    <h1>
      {{ plan?.title || "Plano" }}
      <img src="https://unhide-static-prod.nyc3.cdn.digitaloceanspaces.com/icons/ico-banner-pro.png" alt="" />
    </h1>
    <p>{{ plan?.subtitle || "Esse plano contém erros..." }}</p>
  </div>

  <div class="body">
    <h1 class="price-full">
      R$<span>{{ plan?.price || 0 }}</span>>/MÊS
    </h1>

    <div class="container-select">
      <mat-form-field>
        <mat-select class="unh-select" panelClass="unh-select-panel">
          <mat-option [value]="5">5</mat-option>
          <mat-option [value]="4">4</mat-option>
          <mat-option [value]="3">3</mat-option>
          <mat-option [value]="2">2</mat-option>
          <mat-option [value]="1">1</mat-option>
        </mat-select>
      </mat-form-field>

      Artistas
    </div>

    <button
      mat-button
      class="unh-button-old"
      theme="pink-white"
      [disabled]="!plan?.cycle_months"
      [style.opacity]="plan?.cycle_months ? 1 : 0.5"
    >

    </button>
  </div>
</div>
